// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.acc_section {
  margin: 4rem auto;
}

.accordion-item {
  margin: 1rem 0 !important;
  border: 1px solid #d9d9d9 !important;

  & button {
    font-family: inter !important;
    font-weight: 500 !important;
  }
}

.accordion-body {
  font-family: "Inter" !important;
}

.acc_item {
  margin: 3rem 0;
}


/* -------media-queries--------- */

@media screen and (max-width : 568px) {
  
  .acc_section{
    margin: 2rem auto;
  }

  .acc_item {
    margin: 1.5rem 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/AccordinanSection/acc.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;;EAEpC;IACE,6BAA6B;IAC7B,2BAA2B;EAC7B;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;;AAGA,kCAAkC;;AAElC;;EAEE;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".acc_section {\n  margin: 4rem auto;\n}\n\n.accordion-item {\n  margin: 1rem 0 !important;\n  border: 1px solid #d9d9d9 !important;\n\n  & button {\n    font-family: inter !important;\n    font-weight: 500 !important;\n  }\n}\n\n.accordion-body {\n  font-family: \"Inter\" !important;\n}\n\n.acc_item {\n  margin: 3rem 0;\n}\n\n\n/* -------media-queries--------- */\n\n@media screen and (max-width : 568px) {\n  \n  .acc_section{\n    margin: 2rem auto;\n  }\n\n  .acc_item {\n    margin: 1.5rem 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
